module.exports = __webpack_public_path__ + "static/media/docx-icon.0ce607bd.svg";